import * as React from "react";
import Wait from "../../../wait";
import MobileCreateService from "../../../../../services/mobile/mobile_create";
import PdfViewer from "../../../transacrions/screen/pdf_viewer";
import MobilePopup from "../../mobile_popup";
import ParcelRemark from "../../../../pane/common/remarks";
import PanePayment from "./pane_payment";
import MobileReadService from "../../../../../services/mobile/mobile_read";

export default class PaneParcelDocument extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            doc_frame: <div>Loading...</div>,
            selected: null,
            payments: [],
            documents: []
        }

        this.loadDocument = this.loadDocument.bind(this)
        this.markAsPrinted = this.markAsPrinted.bind(this)
        this.showDocumentAt = this.showDocumentAt.bind(this)
    }

    componentDidMount() {
        this.loadDocument()
    }

    markAsPrinted(action) {
        try {
            Wait.show('Updating...')
            MobileCreateService.addRemark({
                parcelId: this.props.parcel.id,
                stage: action,
                message: ['Marked As Not Printed', 'Marked As Printed'][action - 4]
            }).then(r => {
                try {
                    //document.getElementById('tr_'+d.id).style.display='none'
                    Wait.dismiss()
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    showDocumentAt(data) {
        this.setState({
            selected: data.name,
            doc_frame: <div>
                <PdfViewer key={data.name} base64={data.document} fileName={data.name} height={'66vh'} />
                <div style={{ textAlign: 'right', paddingTop: '8px' }}>
                    <button onClick={() => this.markAsPrinted(5)} className={'submit'}>Mark As Printed</button>
                    <button onClick={() => this.markAsPrinted(4)} className={'refresh'}>Mark As Not Printed</button>
                </div>
            </div>
        })
    }
    render() {
        return (<div className={'row'} style={{ height: '90%' }}>
            <div className={'col col-sm-3'} style={{ height: '100%', background: '#fff', borderRight: '0.5px solid #efefef' }}>
                <div style={{ padding: '8px' }}>
                    <br />
                    <h3>Documents</h3>
                    <hr />
                    {this.state.documents.map((d, i) => {
                        const active = this.state.selected === d.name
                        return (<div key={i} onClick={() => this.showDocumentAt(d)}
                            style={{
                                cursor: 'pointer', padding: '8px', marginLeft: '-8px', marginRight: '-8px',
                                borderLeft: active ? '4px solid #DF4A36' : '4px solid transparent',
                                background: active ? '#DF4A3655' : 'transparent'
                            }}>
                            <span className={'fa fa-file-pdf-o'} style={{ marginRight: '8px', color: '#DF4A36' }} />
                            <b style={{ fontWeight: active ? 'bold' : 'normal' }}>{d.name}</b>
                        </div>)
                    })}
                </div>
            </div>
            <div className={'col col-sm-9'}>
                {this.state.doc_frame}
            </div>
        </div>)
    }

    loadDocument() {
        try {
            Wait.show('Reading Document....')
            MobileReadService.readParcelInfo(this.props.parcel.id).then(r => {
                Wait.dismiss()
                try {
                    switch (r.data.stage) {
                        case 1:
                            this.setState({ doc_frame: <ParcelRemark parcel={this.props.parcel} is_open={false} /> })
                            break
                        case 2:
                            this.setState({ doc_frame: <div>Not Registered, Please Remark it as "Approved" to Generate Documents</div> })
                            break;
                        case 4:
                            Wait.show('Loading Output...')
                            MobileCreateService.createOutput(MobilePopup.id(), this.props.parcel.id, 'parcel').then(r => {
                                try {
                                    Wait.dismiss()
                                    this.setState({ documents: r.data.results })
                                    console.log(r.data.results)

                                    this.showDocumentAt(r.data.results[0])
                                } catch (e) {
                                    console.log(e)
                                }
                            })
                            break
                        case 6:
                            Wait.show('Loading Output...')
                            MobileCreateService.createOutput(MobilePopup.id(), this.props.parcel.id, 'parcel', 'draft').then(r => {
                                try {
                                    Wait.dismiss()
                                    this.setState({ documents: r.data.results })
                                    console.log(r.data.results)

                                    this.showDocumentAt(r.data.results[0])
                                } catch (e) {
                                    console.log(e)
                                }
                            })
                            break
                        case 7:
                            this.setState({ doc_frame: <div>Not Registered, Please Remark it as "Approved" to Generate Documents</div> })
                            break;
                        default:
                            this.setState({ doc_frame: <PanePayment parcel={this.props.parcel} handler={this.loadDocument} /> })
                            break
                    }
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }
}